module.exports = __webpack_public_path__ + "img/pic3.1564c247.png";